import React from 'react';
import { observer } from 'mobx-react-lite';
import { IMInputText, IMSelect, OverlaySpinner } from '@insurancemenu/imenu-components-lib';
import { useHistory } from 'react-router-dom';
import { useRFQProductTemplatesStore } from 'store/pages/rfq/rfq-template/rfq-product-templates/pageStore';
import { ModalType } from '@insurancemenu/imenu-components-lib/dist/helpers/ModalsHelper';
import { IMFormModalStyled } from './styles';
import {
  PRODUCT_TEMPLATES_ADD_PRODUCT_MODAL_INTERNAL_NAME_INPUT_TEST_ID,
  PRODUCT_TEMPLATES_ADD_PRODUCT_MODAL_EXTERNAL_NAME_INPUT_TEST_ID,
  PRODUCT_TEMPLATES_ADD_PRODUCT_MODAL_PRODUCT_LINE_SELECT_TEST_ID,
  PRODUCT_TEMPLATES_ADD_PRODUCT_MODAL_STATE_SELECT_TEST_ID,
  PRODUCT_TEMPLATES_ADD_PRODUCT_MODAL_EFFECTIVE_FROM_INPUT_TEST_ID,
  PRODUCT_TEMPLATES_ADD_PRODUCT_MODAL_EFFECTIVE_TO_INPUT_TEST_ID,
  PRODUCT_TEMPLATES_ADD_PRODUCT_MODAL_TEST_ID,
  PRODUCT_TEMPLATES_ADD_PRODUCT_MODAL_ID,
} from '../../constants';

const CreateRFQTemplateModal = observer((): JSX.Element => {
  const history = useHistory();

  const {
    createTemplateModalDelegate: {
      isVisible: isCreateTemplateModalOpen,
      createTemplateForm,
      modalLoading,
      availableProductLineIdsOptions,
      availableStatesOptions,
      createProductTemplate,
    },
    closeCreateTemplateModal,
  } = useRFQProductTemplatesStore();

  const onSubmit = async (): Promise<void> => {
    const createdTemplate = await createProductTemplate();
    if (createdTemplate?.id) {
      history.push(`/product-template-checklist/${createdTemplate.id}?type=templates`);
    }
    closeCreateTemplateModal();
  };

  return (
    <IMFormModalStyled
      show={isCreateTemplateModalOpen}
      id={PRODUCT_TEMPLATES_ADD_PRODUCT_MODAL_TEST_ID}
      title="Create Product"
      subtitle="Specify basic plan details"
      onClose={closeCreateTemplateModal}
      onSubmit={onSubmit}
      formController={createTemplateForm}
      formId={PRODUCT_TEMPLATES_ADD_PRODUCT_MODAL_ID}
      modalType={ModalType.CREATION}
      data-test-id={PRODUCT_TEMPLATES_ADD_PRODUCT_MODAL_TEST_ID}
      formContent={
        <>
          <IMInputText
            label="Internal Product Name"
            name="internalName"
            $size="full"
            data-test-id={PRODUCT_TEMPLATES_ADD_PRODUCT_MODAL_INTERNAL_NAME_INPUT_TEST_ID}
          />
          <IMInputText
            label="External Product Name"
            name="name"
            $size="full"
            data-test-id={PRODUCT_TEMPLATES_ADD_PRODUCT_MODAL_EXTERNAL_NAME_INPUT_TEST_ID}
          />

          <IMInputText
            label="Effective from"
            name="effectiveFrom"
            htmlType="date"
            $size="m"
            data-test-id={PRODUCT_TEMPLATES_ADD_PRODUCT_MODAL_EFFECTIVE_FROM_INPUT_TEST_ID}
          />
          <IMInputText
            label="Effective to"
            name="effectiveTo"
            htmlType="date"
            $size="m"
            data-test-id={PRODUCT_TEMPLATES_ADD_PRODUCT_MODAL_EFFECTIVE_TO_INPUT_TEST_ID}
          />

          <IMSelect
            label="State"
            name="state"
            options={availableStatesOptions}
            placeholder="Select state"
            $size="m"
            data-test-id={PRODUCT_TEMPLATES_ADD_PRODUCT_MODAL_STATE_SELECT_TEST_ID}
          />
          <IMSelect
            label="Product Line"
            name="productLineId"
            options={availableProductLineIdsOptions}
            placeholder="Select product line"
            $size="m"
            data-test-id={PRODUCT_TEMPLATES_ADD_PRODUCT_MODAL_PRODUCT_LINE_SELECT_TEST_ID}
          />
          <OverlaySpinner display={modalLoading} />
        </>
      }
    />
  );
});

export default CreateRFQTemplateModal;
